import Header from "../components/Header";
import About from "../components/About";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";
import useDocumentTitle from "../useDocumentTitle";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import ScrapingI from "../components/ScrapingI";

function Pages(props) {
  useDocumentTitle(`${props.title} - Umar Faruq Robbany`);

  return (
    props.title === "Home" ?
      <>
        <Header/>
        <About/>
        <Portfolio/>
        <Contact/>
        <Footer/>
      </>
    : <ScrapingI/>
  );
}

export default Pages;